/**
 * The same as parseInt, except NaN is converted to undefined.
 */
export function parseIntSafe(value: string | null | undefined): number | undefined {
    if (!value) {
        return undefined;
    }
    const parsed = parseInt(value);
    return isNaN(parsed) ? undefined : parsed;
}